import { topicItems } from '@/mocks/home';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            话题标签
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            热门话题快速导航，点击探索你感兴趣的爆料方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`group flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full border transition-all duration-300 cursor-pointer ${
                item.hot
                  ? 'bg-accent-50 border-accent-200 hover:border-accent-400 hover:bg-accent-100/80'
                  : 'bg-background-100 border-background-200/70 hover:border-primary-200 hover:bg-primary-50'
              }`}
            >
              <span className={`text-sm md:text-base font-semibold whitespace-nowrap ${
                item.hot ? 'text-accent-700' : 'text-foreground-700'
              }`}>
                #{item.name}
              </span>
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              <span className="text-xs text-foreground-400 ml-1">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}